import { AuthenticationService } from "./authentication.service";
import { environment } from '../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, isDevMode } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from "rxjs/operators";
import { SUBSCRIPTION_CATEGORY } from '../enums';

const endpoint: string = environment.apiUrl;

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json'
  })
};

@Injectable({ providedIn: 'root' })
export class SubscriptionService {
    constructor(
        private auth: AuthenticationService,
        private http: HttpClient
    ) {}

    checkActiveSubscription(categoryId: SUBSCRIPTION_CATEGORY): Observable<boolean> {
        const companyId = this.auth.user().company_id;

        // if(isDevMode())
        // {
        //     return new Observable<boolean>(subscriber => {
        //         subscriber.next(true);
        //         subscriber.complete();
        //     });
        // }

        return this.http
            .get<{ isActive: boolean; error?: string }>(
                `${endpoint}/api/subscription/company/${companyId}/category/${categoryId}/check-active`,
                httpOptions
            )
            .pipe(map(res => res?.isActive ?? false));
    }
}
